import moment from 'moment';
import { GpExpirationStatus } from '../constants';
export var getGPExpirationInfo = function (_a) {
    var expireIn = _a.expireIn, expirationDate = _a.expirationDate;
    // Handle case where expiration date is missing (meaning it hasn't started yet)
    if (!expirationDate || expireIn === undefined) {
        return {
            expirationDate: null,
            expireIn: null,
            isExpired: null,
            expirationStatus: GpExpirationStatus.NOT_STARTED
        };
    }
    var isExpired = moment(expirationDate).isBefore(moment());
    var expirationStatus = GpExpirationStatus.NOTICE;
    if (isExpired) {
        expirationStatus = GpExpirationStatus.EXPIRED;
    }
    else if (expireIn < 30) {
        expirationStatus = GpExpirationStatus.WARNING;
    }
    return {
        expirationDate: expirationDate,
        expireIn: expireIn,
        isExpired: isExpired,
        expirationStatus: expirationStatus
    };
};
